/**
 * Applies the portal's consent decision to Application Insights: the add-in
 * runs the SDK only while the user has agreed to external services.
 */

import { initInsights } from '@this/app-shared/dist/tools/insights/init.js';

import { removeInsightsArtifacts, unloadInsights } from '@this/app-shared/dist/tools/insights/consent.js';
import type { ConsentState } from './messaging.js';

/**
 * Starts Application Insights on `granted` and tears it down otherwise. Never
 * before: even a muted SDK fetches its remote config and sets its cookies.
 */
export function applyConsent(consent: ConsentState) {
    // Only an explicit yes starts the SDK; a repeated yes finds the instance and returns.
    if (consent === 'granted') {
        initInsights('serviceaddin', []);
        return;
    }

    // No and undecided both stop the SDK and clear its identifiers, also in a
    // document that never had an instance but still carries old cookies.
    unloadInsights();
    removeInsightsArtifacts();
}
